// extracted by mini-css-extract-plugin
export default {"overlay":"iz-z","bodyOpen":"jz-z","content":"kz-z","header":"lz-z","close":"mz-z","closeNoHeading":"nz-z"};